/*
	Checks if a string contains any strings in the includers
 */
export function includesStrings(string: string, includers: string[]): boolean {
	return includers.some((c) => string.includes(c))
}
